import "./List-Card.css";
import React from 'react';
  
const ListCard = ({ content }) => { 
       return (
        <div className='list-card'>
            <div className='list-card-content'>
                 {content}
              </div>
        </div>

       );
};

export default ListCard; 